import AllActivities from "../../src/activity/AllActivities";
import { GetStaticProps } from "next";
import { activityUseCase } from "../../src/lib/dependencies";

export default function AllActivitiesPage(props) {
  return <AllActivities {...props}></AllActivities>;
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { ...activityUseCase.getActivities() },
    revalidate: 30,
  };
};
